import React from 'react'

export default function ForamttedEmail(props: {
  email: string
}): React.ReactElement {
  return <a href={`mailto:${props.email}`}>{props.email}</a>
}
